import { type FC, useState, useEffect } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import classnames from 'classnames';
import { Banner } from 'dibs-elements/exports/Banner.tsx';
import { Link } from 'dibs-elements/exports/Link.tsx';

import styles from './MediaErrorBanner.scss';

type Props = {
    message: string | null;
    clearMessage: () => void;
};

export const MediaErrorBanner: FC<Props> = ({ message, clearMessage }) => {
    const [isVisible, setIsVisible] = useState(!!message);

    useEffect(() => {
        setIsVisible(!!message);

        if (message) {
            const timeout = setTimeout(() => setIsVisible(false), 10000);
            return () => clearTimeout(timeout);
        }

        return () => {};
    }, [message]);

    const handleTransitionEnd = (): void => {
        if (!isVisible) {
            clearMessage();
        }
    };

    return (
        <div
            className={classnames(styles.container, { [styles.visible]: !!isVisible })}
            onTransitionEnd={handleTransitionEnd}
        >
            <Banner
                bannerType="error"
                message={
                    <div className={styles.messageBody}>
                        <div className={styles.title}>
                            <FormattedMessage
                                id="nft.publicProfile.mediaUploader.error.title"
                                defaultMessage="Your image could not be uploaded."
                            />
                        </div>
                        <span>{message}</span>{' '}
                        <Link onClick={() => setIsVisible(false)}>
                            <FormattedMessage
                                id="nft.publicProfile.mediaUploader.error.tryAgain"
                                defaultMessage=" Try again"
                            />
                        </Link>
                    </div>
                }
            />
        </div>
    );
};
